import { Route, Routes } from 'react-router-dom';
import React, { useState } from 'react';
import Shell from './shell/shell';
import PageLoader from './pages/PageLoader';
import { OwnProfileResponse } from './store/backendApi';
import { MyTripsPage } from './pages/myTrips/myTripsPage';
import { EditTripPage } from './pages/editTrip/editTripPage';
import { SilentRefresh } from './components/silentRefresh';
import { ProfilePage } from './pages/profile/profilePage';
import { LoginPage } from './pages/login/loginPage';
import { SignOutPage } from './pages/signout';
import NotFoundPage from './pages/notFound/notFoundPage';
import { TripPage } from './pages/trip/tripPage';
import { useTrackPageView } from './hooks/useTrackPageView';

const navElements = [
  {
    element: MyTripsPage,
    name: 'My Trips',
    href: '/',
    hasBack: false,
  },
  {
    element: EditTripPage,
    name: 'Edit Trip',
    href: '/trips/:tripId',
    hasBack: true,
  },
  {
    element: ProfilePage,
    name: 'Profile',
    href: '/profile/:userId',
    hasBack: false,
    sessionOptional: true,
  },
  {
    element: TripPage,
    name: 'Trip',
    href: '/trip/*',
    hasBack: false,
    sessionOptional: true,
  },
  {
    element: TripPage,
    name: 'Trip',
    href: '/p/trip/*',
    hasBack: false,
  },
  {
    element: LoginPage,
    name: 'Login',
    href: '/login',
    hasBack: false,
    sessionOptional: true,
  },
  {
    element: SignOutPage,
    name: 'Singout',
    href: '/signout',
    hasBack: false,
    sessionOptional: true,
  },
  {
    element: NotFoundPage,
    name: 'Not Found',
    href: '/*',
    hasBack: false,
    sessionOptional: true,
  },
];

const App = () => {
  const [profileData, setProfileData] = useState<OwnProfileResponse | undefined | null>();
  useTrackPageView();

  return (
    <>
      <SilentRefresh />
      <Shell profile={profileData}>
        <Routes>
          {navElements.map((nav) => (
            <Route
              key={`r-${nav.name}`}
              path={nav.href}
              element={
                <PageLoader
                  key={`sl-${nav.name}`}
                  setProfileDataData={setProfileData}
                  isSessionOptional={nav.sessionOptional}
                >
                  <nav.element user={profileData} key={`ne-${nav.name}`} />
                </PageLoader>
              }
            />
          ))}
        </Routes>
      </Shell>
    </>
  );
};

export default App;
